"use strict";

exports.__esModule = true;
exports["default"] = exports.SearchIcon = exports.SearchBarFilter = exports.CancelIcon = void 0;

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _propTypes = require("prop-types");

var _styledSystem = require("styled-system");

var _primitives = _interopRequireDefault(require("../../primitives"));

var _elements = require("../glyphs/elements");

var _utils = require("../../utils");

var _custom = _interopRequireDefault(require("../../primitives/custom"));

var _input = _interopRequireDefault(require("../input-component/input"));

var _container = _interopRequireDefault(require("../form-ui/container"));

var _placeholderLabel = _interopRequireDefault(require("./placeholder-label"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SearchIcon = (0, _styledComponents["default"])(_elements.NavSearch).withConfig({
  displayName: "search-bar-filter__SearchIcon",
  componentId: "sc-1khvzwk-0"
})(["", ";", ";"], (0, _styledSystem.compose)(_styledSystem.color, _styledSystem.height, _styledSystem.width), _custom["default"]);
exports.SearchIcon = SearchIcon;
var CancelIcon = (0, _styledComponents["default"])(_elements.NavClose).withConfig({
  displayName: "search-bar-filter__CancelIcon",
  componentId: "sc-1khvzwk-1"
})(["cursor:pointer;", ";", ";"], (0, _styledSystem.compose)(_styledSystem.color, _styledSystem.height, _styledSystem.width), _custom["default"]);
exports.CancelIcon = CancelIcon;
var inputStyles = {
  alignItems: "center",
  color: "gray-dark",
  mt: "2px"
};
var selectionCountStyles = {
  color: "white",
  fontSize: 0,
  fontWeight: 500,
  letterSpacing: "0.3px",
  lineHeight: 2,
  textAlign: "right"
};
var selectionBoxStyles = {
  alignItems: "center",
  backgroundColor: "secondary-blue",
  borderRadius: "10px",
  height: 20,
  justifyContent: "center",
  m: 1,
  width: 20
};
var searchIconStyles = {
  alignItems: "center",
  ml: 1,
  mt: 1,
  width: 21
};
var cancelIconStyles = {
  alignItems: "center",
  ml: 1,
  width: 21
};
var propTypes = {
  /** color for the search box */
  borderColor: _propTypes.string,

  /** Label for the input field */
  label: _propTypes.string,

  /** onBlur event handler - used to process the event */
  onBlur: _propTypes.func,

  /** used to close the dropdown and empty the search */
  onCancelClick: _propTypes.func,

  /** Input onChange function */
  onChange: _propTypes.func,

  /** Input onFocus function */
  onFocus: _propTypes.func,

  /** Height for the outer Flex container */
  searchBarHeight: (0, _propTypes.oneOfType)([_propTypes.number, _propTypes.array, _propTypes.string]),

  /** Width for the outer Flex container */
  searchBarWidth: (0, _propTypes.oneOfType)([_propTypes.number, _propTypes.array, _propTypes.string]),

  /** Selection count value */
  selectionCount: _propTypes.number,

  /** If true then show the cancel icon */
  showCancel: _propTypes.bool,

  /** Content rendered in suggestions container */
  suggestions: _propTypes.node,

  /** Input text value */
  value: _propTypes.string
};

var SearchBarFilter = function SearchBarFilter(_ref) {
  var onCancelClick = _ref.onCancelClick,
      onChange = _ref.onChange,
      onFocus = _ref.onFocus,
      showCancel = _ref.showCancel,
      _ref$value = _ref.value,
      value = _ref$value === void 0 ? "" : _ref$value,
      _ref$label = _ref.label,
      label = _ref$label === void 0 ? "Search Chipsets" : _ref$label,
      onBlur = _ref.onBlur,
      _ref$searchBarHeight = _ref.searchBarHeight,
      searchBarHeight = _ref$searchBarHeight === void 0 ? "45px" : _ref$searchBarHeight,
      _ref$searchBarWidth = _ref.searchBarWidth,
      searchBarWidth = _ref$searchBarWidth === void 0 ? "100%" : _ref$searchBarWidth,
      selectionCount = _ref.selectionCount,
      borderColor = _ref.borderColor;

  var _useFocus = (0, _utils.useFocus)(false, onBlur, onFocus),
      hasFocus = _useFocus[0],
      handleBlur = _useFocus[1],
      handleFocus = _useFocus[2];

  var hasLabel = (0, _react.useMemo)(function () {
    return !!label;
  }, [label]);
  var showValue = (0, _react.useMemo)(function () {
    return hasFocus || value.length > 0;
  }, [hasFocus, value]);
  return /*#__PURE__*/_react["default"].createElement(_container["default"], {
    borderColor: borderColor,
    height: searchBarHeight,
    showValue: showValue,
    width: searchBarWidth
  }, /*#__PURE__*/_react["default"].createElement(_primitives["default"].Flex, {
    position: "relative",
    width: searchBarWidth
  }, label && /*#__PURE__*/_react["default"].createElement(_placeholderLabel["default"], {
    hasFocus: hasFocus,
    label: label,
    showValue: showValue
  }), /*#__PURE__*/_react["default"].createElement(_input["default"], _extends({
    handleBlur: handleBlur,
    handleChange: onChange,
    handleFocus: handleFocus,
    hasLabel: hasLabel,
    showValue: showValue,
    value: value
  }, inputStyles)), showCancel || hasFocus ? /*#__PURE__*/_react["default"].createElement(_primitives["default"].Flex, _extends({}, cancelIconStyles, {
    onClick: onCancelClick
  }), /*#__PURE__*/_react["default"].createElement(CancelIcon, {
    fill: "black",
    height: 16,
    width: 16
  })) : /*#__PURE__*/_react["default"].createElement(_primitives["default"].Flex, searchIconStyles, /*#__PURE__*/_react["default"].createElement(SearchIcon, {
    fill: "black",
    height: 21,
    width: 21
  })), /*#__PURE__*/_react["default"].createElement(_primitives["default"].Flex, {
    alignItems: "center"
  }, /*#__PURE__*/_react["default"].createElement(_primitives["default"].Flex, selectionBoxStyles, /*#__PURE__*/_react["default"].createElement(_primitives["default"].Text, selectionCountStyles, selectionCount)))));
};

exports.SearchBarFilter = SearchBarFilter;
SearchBarFilter.propTypes = propTypes;
SearchBarFilter.displayName = "Modules.SearchBarFilter";
var _default = SearchBarFilter;
exports["default"] = _default;